export default {
  label: {
    info_pc: "You can check your order history from My Page. </br> * Cannot be used by those who purchased without registering on My Page. </br> Please log in from the login icon at the top right of the screen.",
    info_sp: "You can check your order history from My Page. </br> * Those who purchased without registering on My Page </br> cannot use it. </br> Please log in from the login icon at the top right of the screen."
  }
}